<template>
    <div
        :class="['table-bulk-action-container', topScrollPosition > 150 ? 'sticky' : '']"
        v-if="selectedOrderIds.length"
    >
        <div>{{ selectedOrderIds.length }} order{{ selectedOrderIds.length > 1 ? 's' : '' }} selected.</div>
        <div>
            <md-button
                v-if="actionsToDisplay.includes('sendSchedulingLink')"
                class="md-warning bulk-action-btn"
                title="Send SMS"
                @click="sendSchedulingLink"
            >
                <md-icon>schedule_send</md-icon>
                Send SMS
            </md-button>
            <md-button
                v-if="actionsToDisplay.includes('batchAssign')"
                class="md-success bulk-action-btn"
                title="Batch Assign to Carrier"
                @click="handleBatchAssignClicked"
            >
                Batch assign to carrier
            </md-button>
            <md-button
                v-if="actionsToDisplay.includes('readyForPacking')"
                class="md-button-custom-ready-for-packing bulk-action-btn"
                title="Ready for Packing"
                @click="handleReadyForPackingClicked"
            >
                Ready for Packing
            </md-button>
            <md-button
                v-if="actionsToDisplay.includes('bookNow')"
                class="md-success bulk-action-btn"
                title="Book Now"
                @click="handleBookNowClicked"
            >
                Book Now
            </md-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'OrdersTableHeaderActions',
    props: {
        selectedOrderIds: {
            type: Array,
            required: true
        },
        topScrollPosition: {
            type: Number,
            default: 0
        },
        /**
         * Props to control the visibility of the action buttons
         */
        actionsToDisplay: {
            type: Array,
            default: () => ['sendSchedulingLink'],
            validator(value) {
                const validActions = ['batchAssign', 'sendSchedulingLink', 'readyForPacking', 'bookNow'];
                return value.every((action) => validActions.includes(action));
            }
        }
    },
    methods: {
        sendSchedulingLink() {
            this.$emit('scheduling-link-button-clicked');
        },
        handleReadyForPackingClicked() {
            this.$emit('ready-for-packing-button-clicked');
        },
        handleBookNowClicked() {
            this.$emit('book-now-button-clicked');
        },
        handleBatchAssignClicked() {
            this.$emit('batch-assign-clicked');
        }
    }
};
</script>

<style scoped lang="scss">
.table-bulk-action-container {
    .bulk-action-btn {
        width: 180px;
    }
}

.md-button-custom-ready-for-packing {
    background: #1c3e61 !important;
    color: #fff !important;
}
</style>
